import { ValidationError } from '~/errors';
import { BaseRestRepository } from './baseRestRepository';
import type { LeaseMoveOutRequestDto, SetLeaseMoveOutRequestDto } from '~/swagger/Api';

const LEASES_URL = '/api/leases';

export class LeaseMoveOutRepository extends BaseRestRepository {
  public async getMoveOutRequests(leaseId: string): Promise<LeaseMoveOutRequestDto[]> {
    if (!leaseId) throw new ValidationError('leaseId must be provided');
    const url = `${LEASES_URL}/${leaseId}/move-outs`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async addMoveOutRequest(leaseId: string, payload: SetLeaseMoveOutRequestDto): Promise<LeaseMoveOutRequestDto> {
    if (!leaseId) throw new ValidationError('leaseId must be provided');
    if (!payload?.moveOutDate) throw new ValidationError('moveOutDate must be provided');
    const url = `${LEASES_URL}/${leaseId}/move-outs`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }

  public async acceptMoveOutRequest(leaseId: string, moveOutRequestId: string): Promise<LeaseMoveOutRequestDto> {
    if (!leaseId) throw new ValidationError('leaseId must be provided');
    if (!moveOutRequestId) throw new ValidationError('moveOutRequestId must be provided');
    const url = `${LEASES_URL}/${leaseId}/move-outs/${moveOutRequestId}/accept`;
    const response = await this.fetchWithAuth(url, { method: 'POST' });
    return this.getJsonResponse(response);
  }

  public async rejectMoveOutRequest(leaseId: string, moveOutRequestId: string): Promise<LeaseMoveOutRequestDto> {
    if (!leaseId) throw new ValidationError('leaseId must be provided');
    if (!moveOutRequestId) throw new ValidationError('moveOutRequestId must be provided');
    const url = `${LEASES_URL}/${leaseId}/move-outs/${moveOutRequestId}/reject`;
    const response = await this.fetchWithAuth(url, { method: 'POST' });
    return this.getJsonResponse(response);
  }
}

export const leaseMoveOutRepository = new LeaseMoveOutRepository();
